var _style, _polygon, _polygon2, _polygon3, _polygon4, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanefilterLoader1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#376FB6;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#3FB66B;}\n\t.st3{fill:#3FB66B;stroke:#3FB66B;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.2,123.99 90.66,94.24 194.3,92.59 93.77,325.63 61.23,325.63 151.51,122.34  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212.58,92.59 198.84,126.47 275.11,126.47 289.9,92.59  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.8226,
    y1: 197.6913,
    x2: 226.7262,
    y2: 197.6913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3FB66B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    style: {
      stopColor: "#40B26F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5916,
    style: {
      stopColor: "#3EA47D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7475,
    style: {
      stopColor: "#3981A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    style: {
      stopColor: "#376FB6"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "196.51,133.65 226.73,133.65 176.66,261.74 129.82,261.74 141.25,234.19 156.46,233.58  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.29,261.74 71.33,233.64 96.35,233.64 83.96,261.74  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.8,25.99c13.28,0.91,26.29,12.83,26.03,28.63c-0.26,15.71-13.53,27.05-26.61,27.57 c-14.75,0.58-29.48-12.58-28.92-29.21C178.83,36.88,193.46,25.01,207.8,25.99z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ball"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.94,325.53c-10.31,0.19-19.09-9.04-18.73-19.89c0.33-10.13,8.52-18.33,18.09-18.52 c9.58-0.19,18.07,7.7,18.73,17.83C186.74,315.79,178.26,325.34,167.94,325.53z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanefilterLoader1);
export default __webpack_public_path__ + "static/media/banefilter-loader1.0572273ab9d76992b4ca7828fa4bb32f.svg";
export { ForwardRef as ReactComponent };